import { useTranslation } from "react-i18next";
import { LocationInventory } from "../../../features/FloorManager/typings/location-inventory";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";

export function useRemoteFetchLocations() {
  const { t } = useTranslation();
  return useRemoteMutation<LocationInventory[], RemoteApiError, void>({
    key: ["allLocations"],
    method: "get",
    url: "/location",
    snackbarTextOnFail: t("There was an error retrieving locations")
  });
}
